import React, { useState } from 'react';
import { CheckCircle2Icon, Loader2Icon, SendIcon } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
import { QUOTE_MESSAGE } from '../utils/contact';
const serviceOptions = ['Página web de alta conversión', 'Google Business', 'Google Ads', 'SEO básico', 'Administración de redes sociales', 'Página para producto digital', 'Academias y Deportes', 'Otro'];
interface FormState {
  nombre: string;
  email: string;
  telefono: string;
  pais: string;
  negocio: string;
  servicio: string;
  mensaje: string;
}
const emptyForm: FormState = {
  nombre: '',
  email: '',
  telefono: '',
  pais: '',
  negocio: '',
  servicio: '',
  mensaje: ''
};
const fieldClass = 'w-full rounded-xl border border-white/12 bg-ink-950 px-4 py-3 text-sm text-white placeholder:text-mist-dim transition-colors duration-200 ease-out focus:border-neon focus:outline-none';
export function ContactForm() {
  const [form, setForm] = useState<FormState>(emptyForm);
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [error, setError] = useState<string | null>(null);
  const update = (key: keyof FormState) => (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setForm(prev => ({
      ...prev,
      [key]: event.target.value
    }));
  };
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!form.nombre.trim() || !form.email.trim() || !form.servicio) {
      setStatus('error');
      setError('Completa tu nombre, correo y el servicio de interés para enviar la solicitud.');
      return;
    }
    setError(null);
    setStatus('sending');
    window.setTimeout(() => {
      setStatus('sent');
      setForm(emptyForm);
    }, 900);
  };
  return <section id="contacto" className="scroll-mt-24 py-20 lg:py-28" data-id="element-26" data-mp="vv14kcgo7061">
      <div className="mx-auto max-w-3xl px-5 lg:px-8" data-id="element-27" data-mp="zvush5u44eyx">
        <div className="rounded-3xl border border-neon/40 bg-ink-900 p-7 shadow-glow sm:p-10" data-id="element-28" data-mp="zu9x5dzz4s00">
          <div aria-hidden="true" className="h-px w-16 bg-neon/70" data-id="element-29" data-mp="2wuxoe8won9ux" />
          <h2 className="mt-6 text-3xl font-semibold tracking-tight text-white" data-id="element-30" data-mp="2ry79howm6kb3">
            Solicita tu cotización
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-mist-muted" data-id="element-31" data-mp="35wnfteqke8sp">
            Cuéntame sobre tu negocio y te responderé con una propuesta personalizada.
          </p>

          {status === 'sent' ? <div role="status" className="mt-8 flex items-start gap-3 rounded-2xl border border-neon/50 bg-neon/8 p-6" data-id="element-32" data-mp="2d8rlggogwsz3">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-neon" aria-hidden="true" data-id="element-33" data-mp="2mykupb150w06" />
              <div data-id="element-34" data-mp="2i7ckwdvwb8mh">
                <p className="text-sm font-medium text-white" data-id="element-35" data-mp="2i6t5p4xmqyc5">¡Solicitud enviada!</p>
                <p className="mt-1 text-sm leading-relaxed text-mist-muted" data-id="element-36" data-mp="1ugysgm9ef7rd">
                  Gracias por escribirme. Revisaré tu proyecto y te contactaré muy pronto.
                </p>
                <button type="button" onClick={() => setStatus('idle')} className="mt-4 text-sm font-medium text-neon underline-offset-4 transition-colors duration-200 ease-out hover:underline" data-id="element-37" data-mp="50mqm9ue3keq">
                  Enviar otra solicitud
                </button>
              </div>
            </div> : <form onSubmit={handleSubmit} noValidate className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-38" data-mp="op5aqd0jg7mk">
              <div className="sm:col-span-2" data-id="element-39" data-mp="sq79ksqjmho0">
                <label htmlFor="nombre" className="mb-2 block text-xs text-mist-muted" data-id="element-40" data-mp="spxkd7dboejd">
                  Nombre completo
                </label>
                <input id="nombre" name="nombre" type="text" autoComplete="name" value={form.nombre} onChange={update('nombre')} placeholder="Tu nombre y apellido" className={fieldClass} data-id="element-41" data-mp="jpsqm011xeno" />
              </div>

              <div data-id="element-42" data-mp="3jqy9xji1obch">
                <label htmlFor="email" className="mb-2 block text-xs text-mist-muted" data-id="element-43" data-mp="3eyycpytczwjl">
                  Correo electrónico
                </label>
                <input id="email" name="email" type="email" autoComplete="email" value={form.email} onChange={update('email')} placeholder="tucorreo@email.com" className={fieldClass} data-id="element-44" data-mp="3ay4of4c08fq6" />
              </div>

              <div data-id="element-45" data-mp="3tnkqvx792i98">
                <label htmlFor="telefono" className="mb-2 block text-xs text-mist-muted" data-id="element-46" data-mp="3tn1gd1jxiw58">
                  Teléfono
                </label>
                <input id="telefono" name="telefono" type="tel" autoComplete="tel" value={form.telefono} onChange={update('telefono')} placeholder="+1 000 000 0000" className={fieldClass} data-id="element-47" data-mp="3oqub7azcxooc" />
              </div>

              <div data-id="element-48" data-mp="285iolqfapdnl">
                <label htmlFor="pais" className="mb-2 block text-xs text-mist-muted" data-id="element-49" data-mp="2850k66ihbt4l">
                  País
                </label>
                <input id="pais" name="pais" type="text" autoComplete="country-name" value={form.pais} onChange={update('pais')} placeholder="Estados Unidos, Perú, México…" className={fieldClass} data-id="element-50" data-mp="2huk31c66zmzg" />
              </div>

              <div data-id="element-51" data-mp="2vs8lkdcsei1c">
                <label htmlFor="negocio" className="mb-2 block text-xs text-mist-muted" data-id="element-52" data-mp="30telav4v75kd">
                  Tipo de negocio
                </label>
                <input id="negocio" name="negocio" type="text" value={form.negocio} onChange={update('negocio')} placeholder="Limpieza, gym, belleza, e-commerce…" className={fieldClass} data-id="element-53" data-mp="11hlrf7ddigbv" />
              </div>

              <div className="sm:col-span-2" data-id="element-54" data-mp="18cvgwcvtbwn8">
                <label htmlFor="servicio" className="mb-2 block text-xs text-mist-muted" data-id="element-55" data-mp="18dmzmn4b9zw3">
                  Servicio de interés
                </label>
                <select id="servicio" name="servicio" value={form.servicio} onChange={update('servicio')} className={`${fieldClass} appearance-none`} data-id="element-56" data-mp="1hdjs6zttniwf">
                  <option value="" data-id="element-57" data-mp="1r2tkafoo11kj">Selecciona una opción</option>
                  {serviceOptions.map(option => <option key={option} value={option} data-id="element-58" data-mp="1m6cwxnpair8i">
                      {option}
                    </option>)}
                </select>
              </div>

              <div className="sm:col-span-2" data-id="element-59" data-mp="1w4an4gqpmy3r">
                <label htmlFor="mensaje" className="mb-2 block text-xs text-mist-muted" data-id="element-60" data-mp="2er0123829mh7">
                  Mensaje / Cuéntame sobre tu proyecto
                </label>
                <textarea id="mensaje" name="mensaje" rows={5} value={form.mensaje} onChange={update('mensaje')} placeholder="¿Qué necesita tu negocio ahora mismo?" className={`${fieldClass} resize-none`} data-id="element-61" data-mp="2jnqml62mxaa0" />
              </div>

              {status === 'error' && error ? <p role="alert" className="text-sm text-rose-300 sm:col-span-2" data-id="element-62" data-mp="1mzkgeeq2e9tm">
                  {error}
                </p> : null}

              <div className="sm:col-span-2" data-id="element-63" data-mp="1r1yy2vhzz3jb">
                <button type="submit" disabled={status === 'sending'} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-neon px-7 py-4 text-base font-medium text-ink-950 shadow-glow transition-[background-color,transform] duration-200 ease-out hover:bg-neon-soft active:translate-y-px disabled:cursor-not-allowed disabled:opacity-70 sm:w-auto" data-id="element-64" data-mp="1d1ec5qgscrll">
                  {status === 'sending' ? <>
                      <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-65" data-mp="1jj94zmg7j1ci" />
                      Enviando…
                    </> : <>
                      <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-66" data-mp="19t6bzm935ne6" />
                      Enviar solicitud
                    </>}
                </button>
              </div>
            </form>}

          <div className="mt-8 border-t border-white/8 pt-6" data-id="element-67" data-mp="10t9h32w3rsao">
            <p className="text-sm text-mist-muted" data-id="element-68" data-mp="vt59k2d6a7wl">
              También puedes escribirme directamente por WhatsApp para una atención más rápida.
            </p>
            <WhatsAppButton message={QUOTE_MESSAGE} variant="outline" className="mt-4" data-id="element-69" data-mp="quu1nx6fu7h0">
              Escribir por WhatsApp
            </WhatsAppButton>
          </div>
        </div>
      </div>
    </section>;
}